<template>
    <div class="state-outer" :class="{ [value]: true, 'line': line }">
        <div class="state-inner">
            <span class="state-indicator"></span>
            <span class="state-title" v-if="!line">{{ value }}</span>
        </div>
    </div>
</template>

<script>
import { defineComponent, onMounted, reactive, ref } from "vue";

export default defineComponent({
    name: "state",
    props: {
        value: {
            type: String,
            required: true,
            default: ""
        },
        line: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    setup() {

        return {

        };
    },
});
</script>

<style>
.state-outer {
    display:flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 5px;
    margin-bottom: 7px;

    &.line {
        width:100%;
        max-width:100%;
        margin:15px 0 5px;
        border-radius:0;
        background:none transparent;
        &:first-child:last-child {
            margin: 5px 0;
        }
        .state-inner {
            border-radius:0;
            width:100%;
            margin-right:0;
            padding:0;
            background:none transparent;
            .state-indicator {
                width:100%;
                border-radius:0;
                height:4px;
            }
        }
    }

    .state-inner {
        padding: 7px 8px;
        border-radius: 11px;
        margin:0;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin-right: auto;
        position: relative;
        overflow: hidden;
        width: auto;
        clear: both;
        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background: var(--state, #37db87);
            opacity: 0.1;
        }
    }
}
.state-title {
    text-transform: uppercase;
    line-height: 1;
    letter-spacing: 0.1em;
    font-size: 9px;
}
.state-indicator {
    font-family: "FontAwesome";
    width: 10px;
    height: 10px;
    display: block;
    border-radius: 50%;
    color: #fff;
    background:var(--state,#37db87);
    margin-right:5px;
    &::before {
        font-size: 10px;
        line-height: 1;
        position: absolute;
        left: 50%;
        top: 50%;
        width: 10px;
        text-align: center;
        transform: translate(-50%, -50%);
    }
}
</style>